import { render } from "./HoodSpace.vue?vue&type=template&id=bf9a255a"
import script from "./HoodSpace.vue?vue&type=script&lang=js"
export * from "./HoodSpace.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__